import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ALL, CALL, COMMENT, DASBOARDSUMMARY, DOWNLOADCSV, DOWNLOADTRANSCRIPT, GETBOOKINGDATA, GETCALLDETAILBYID, GETCONVERSATIONDETAILBYID, IDLE, REBOOK, RESTARTAGENT, UPDATEBOOKINGDATA, UPDATEREASONSTATUS } from 'src/common/constants';
import { composeThunkAction } from "src/common/utils";
import { apiDownloadReport, apiDownloadTranscript, apiGetAllCall, apiGetBookingData, apiGetCallDetailById, apiGetConverstaionDetailById, apiGetDashboardSummary, apiRebook, apiRestartAgent, apiUpdateComment, apiUpdateReasonStatus, apiUpdatetBookingData } from 'src/services/call.service';
interface CallState {
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
    showCallDetailsModal: any;
    showReportModal: boolean;
    callId: string;
    isPlaying: boolean;
    statusReasonValue: boolean;
    commentValue: string;
}
const initialState: CallState = {
    status: IDLE,
    error: null,
    showCallDetailsModal: false,
    showReportModal: false,
    callId: '',
    isPlaying: false,
    statusReasonValue: false,
    commentValue: '',
}

export const getAllCallHandler = createAsyncThunk(
    composeThunkAction(CALL, ALL),
    async (data: { pageLimit: number, pageNumber: number, searchVal: string }, { rejectWithValue }) => {
        try {
            const response = await apiGetAllCall(data);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    }
);

export const getCallDetailsByIdHandler = createAsyncThunk(
    composeThunkAction(CALL, GETCALLDETAILBYID),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiGetCallDetailById(data);
            return response;
        }
        catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    })


export const getConversationDetailsByIdHandler = createAsyncThunk(
    composeThunkAction(CALL, GETCONVERSATIONDETAILBYID),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiGetConverstaionDetailById(data);
            return response;
        }
        catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    })

export const restartAgent = createAsyncThunk(
    composeThunkAction(CALL, RESTARTAGENT),
    async () => {
        try {
            const response = await apiRestartAgent();
            return response;
        }
        catch (error: any) {
            return error.response?.data?.message || error.message
        }
    })

export const downloadCSV = createAsyncThunk(
    composeThunkAction(CALL, DOWNLOADCSV),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiDownloadReport(data.startDate, data.endDate, data.timezoneOffset);
            return response;
        }
        catch (error: any) {
            return error.response?.data?.message || error.message
        }
    })

export const downloadTranscript = createAsyncThunk(
    composeThunkAction(CALL, DOWNLOADTRANSCRIPT),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiDownloadTranscript(data);
            return response;
        }
        catch (error: any) {
            return error.response?.data?.message || error.message
        }
    })

export const updateReason = createAsyncThunk(
    composeThunkAction(CALL, UPDATEREASONSTATUS),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiUpdateReasonStatus(data);
            return response;
        }
        catch (error: any) {
            return error.response?.data?.message || error.message
        }
    })

export const reBook = createAsyncThunk(
    composeThunkAction(CALL, REBOOK),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiRebook(data);
            return response;
        }
        catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    })

export const updateComment = createAsyncThunk(
    composeThunkAction(CALL, COMMENT),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiUpdateComment(data);
            return response;
        }
        catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    })

export const getBookingDetails = createAsyncThunk(
    composeThunkAction(CALL, GETBOOKINGDATA),
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiGetBookingData(data);
            return response;
        }
        catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    })

export const updateBookingDetails = createAsyncThunk(
    composeThunkAction(CALL, UPDATEBOOKINGDATA),
    async (
        data: { callId: string; payload: any },
        { rejectWithValue }
    ) => {
        try {
            const response = await apiUpdatetBookingData(data.callId, data.payload);
            return response;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "An error occurred"
            );
        }
    }
);

export const getDashboardData = createAsyncThunk(
    composeThunkAction(CALL, DASBOARDSUMMARY),
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiGetDashboardSummary();
            return response;
        }
        catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message || 'An error occurred');
        }
    })

const callSlice = createSlice({
    name: 'callSlice',
    initialState,
    reducers: {
        callDetailModal: (state, { payload }: PayloadAction<any>) => {
            state.showCallDetailsModal = payload;
        },
        closeReportModal: (state) => {
            state.showReportModal = false;
        },
        showReportModalHandler: (state) => {
            state.showReportModal = true;
        },
        callIdHandler: (state, { payload }: PayloadAction<any>) => {
            state.callId = payload;
        },
        audioPlaying: (state, { payload }: PayloadAction<any>) => {
            state.isPlaying = payload;
        },
        callStatusReasonHandler: (state, { payload }: PayloadAction<any>) => {
            state.statusReasonValue = payload;
        },
        callCommentHandler: (state, { payload }: PayloadAction<any>) => {
            state.commentValue = payload;
        },
    },
});

export const { closeReportModal, showReportModalHandler, callIdHandler, audioPlaying, callStatusReasonHandler, callCommentHandler, callDetailModal,} = callSlice.actions;

export default callSlice.reducer;   